const ROOT = '/api/sub-company-checklists';

export class SubCompanyChecklistsAuthoringApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getChecklists({ skipForbiddenError, ...params }) {
    return this.#http.get(ROOT, {
      params,
      ...(skipForbiddenError && { skipResponseInterceptor: { forbiddenError: true } }),
    });
  }

  async getChecklist({ checklistId, ...params }) {
    return this.#http.get(`${ROOT}/${checklistId}`, { params });
  }

  // One node's own expressions — see the loan-target sibling for why the checklist-wide read is not
  // an acceptable substitute for an item.
  async getChecklistCategory({ checklistId, categoryId }) {
    return this.#http.get(`${ROOT}/${checklistId}/categories/${categoryId}`);
  }

  async getChecklistItem({ checklistId, itemId }) {
    return this.#http.get(`${ROOT}/${checklistId}/items/${itemId}`);
  }

  async editChecklist({ skipRecalculation, ...body }) {
    return this.#http.put(`${ROOT}/${body.checklistId}`, body, {
      params: { skipRecalculation },
    });
  }

  async createChecklist(body) {
    return this.#http.post(ROOT, body);
  }

  async createChecklistCategory(body) {
    return this.#http.post(`${ROOT}/${body.checklistId}/categories`, body);
  }

  async createChecklistItem({ checklistId, categoryId, ...body }) {
    return this.#http.post(`${ROOT}/${checklistId}/categories/${categoryId}/items`, body);
  }

  async deleteChecklist({ checklistId }) {
    return this.#http.delete(`${ROOT}/${checklistId}`);
  }

  async deleteChecklistCategory({ checklistId, categoryId }) {
    return this.#http.delete(`${ROOT}/${checklistId}/categories/${categoryId}`);
  }

  async deleteChecklistItem({ checklistId, categoryId, itemId }) {
    return this.#http.delete(`${ROOT}/${checklistId}/categories/${categoryId}/items/${itemId}`);
  }

  async disableGlobalChecklist({ checklistId }) {
    return this.#http.post(`${ROOT}/${checklistId}/disable`);
  }

  async enableGlobalChecklist({ checklistId }) {
    return this.#http.post(`${ROOT}/${checklistId}/enable`);
  }

  async cloneGlobalChecklist({ checklistId }) {
    return this.#http.post(`${ROOT}/${checklistId}/clone`);
  }

  async disableGlobalChecklistNode({ categoryId, itemId }) {
    return this.#http.post(`${ROOT}/nodes/disable`, null, {
      params: { categoryId, itemId },
    });
  }

  async enableGlobalChecklistNode({ categoryId, itemId }) {
    return this.#http.post(`${ROOT}/nodes/enable`, null, {
      params: { categoryId, itemId },
    });
  }

  async setChecklistVisibilityOverride(body) {
    return this.#http.post(`${ROOT}/visibility-override`, body);
  }

  async removeChecklistVisibilityOverride({ checklistId, categoryId, itemId }) {
    return this.#http.delete(`${ROOT}/visibility-override`, {
      params: { checklistId, categoryId, itemId },
    });
  }

  async getChecklistsExpressionDefinition() {
    return this.#http.get(`${ROOT}/expression-definition`);
  }

  async getChecklistsVisibilityDefinition() {
    return this.#http.get(`${ROOT}/expression-definition-visibility`);
  }
}
